var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({staticClass:"ma-1",attrs:{"small":"","label":"","color":_vm.color}},on),[_vm._v(_vm._s(_vm.initials))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.fullName))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }